import * as React from 'react';
import { useLocation } from '@reach/router';
import { type IGatsbyImageData } from 'gatsby-plugin-image';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { createUseCaseLink, navigate } from '../../utils';
import { Text } from '../design-system';

import {
  Author,
  GridItemWrapper,
  StyledInfo,
  StyledPreviewImage,
  Title
} from './sharedStyles';

const Wrapper = styled(GridItemWrapper)`
  flex-direction: column;
`;

export interface UseCaseItem {
  author?: string;
  category: {
    title: string;
  };
  featured: boolean;
  gridImage: {
    gatsbyImageData: IGatsbyImageData;
    title: string;
    url: string;
  };
  name: string;
  seoMetaDescription: string;
  slug: string;
}

interface UseCaseGridItemProps {
  categoryPage?: boolean;
  useCase: UseCaseItem;
}

export const UseCaseGridItem: React.ComponentType<UseCaseGridItemProps> =
  React.memo(({ useCase }) => {
    const { search } = useLocation();

    return (
      <Wrapper
        key={useCase.slug}
        onClick={() => {
          navigate(createUseCaseLink(useCase), search);
        }}>
        <StyledPreviewImage>
          {useCase.gridImage && (
            <GatsbyImage
              alt={useCase.gridImage.title}
              image={useCase.gridImage.gatsbyImageData}
              sizes="420px"
            />
          )}
        </StyledPreviewImage>
        <StyledInfo>
          <Title renderAs="h4">{useCase.name}</Title>
          {useCase.author && <Author>{useCase.author}</Author>}
          {/* this used to be shortDescription, but it's the same content as seoMetaDescription */}
          {/* so we're just using seoMetaDescription outside of SEO context for this one case */}
          {/* to be efficient with Contentful fields */}
          <Text size="medium">{useCase.seoMetaDescription}</Text>
        </StyledInfo>
      </Wrapper>
    );
  });
